// extracted by mini-css-extract-plugin
export default {"loginTeams":"TeamsLogin_loginTeams__Nnysb","error":"TeamsLogin_error__UOj-A"};